<template lang="pug">
#tabela-gestao-contrato-originacao-empresa
    .tabela-gestao-contrato-originacao__tabela
        el-table(
            :key="listagemTableKey('solicitacao-car', tabelaData, (paginacao.pagina + 1) || 1)",
            :data='this.tabelaData',
            v-loading='this.carregandoTabela',
            stripe,
            :default-sort='{ prop: "date", order: "descending" }',
            style='width: 100%',
            ref='multipleTable'
        )
            el-table-column(
                prop='nomeTerritorio',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.territorio")',
                align='left',
                sortable
            )
            el-table-column(
                prop='analiseDataSolicitacao',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.dataSolicitacao")',
                align='left',
                sortable,
                width='250'
            )
            el-table-column(
                prop='analiseDataResposta',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.dataResposta")',
                align='left',
                sortable,
                width='250'
            )
            el-table-column(
                prop='statusAnalise',
                :label='$t("mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.statusAnalise")',
                align='left',
                sortable,
                width='250'
            )
                .template(slot-scope='scope')
                    el-tag(
                        :type='!scope.row.statusAnalise ? "warning" : "info"',
                        size='small'
                    )
                        i.el-icon(
                            :class='!scope.row.statusAnalise ? "el-icon-warning-outline" : "el-icon-circle-check"'
                        )
                        span {{ scope.row.statusAnalise ? $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.analisado') : $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.analisePendente') }}
            el-table-column(label='', align='center', width='45')
                .template.d-flex.justify-content-center.tabela-gestao-icone(
                    slot-scope='scope'
                )
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='analisarSolicitacao(scope.row)',
                                :disabled='habilitarBotaoAnalise(scope.row.statusAnalise)',
                                v-if='interfaceUsuario === "empresa" && !scope.row.statusAnalise'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.analisar') }}

                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='analisarSolicitacao(scope.row)',
                                :disabled='!scope.row.statusAnalise',
                                v-if='interfaceUsuario === "empresa" && scope.row.statusAnalise'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.visualizarAnalise') }}

                            el-dropdown-item(
                                :icon='carregandoBaixarLaudo ? "el-icon-loading" : "el-icon-download"',
                                :disabled='!scope.row.arquivoLaudo || carregandoBaixarLaudo',
                                @click.native='baixarLaudo(scope.row.idLaudo)'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.baixarLaudo') }}

                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='analisarSolicitacao(scope.row)',
                                :disabled='habilitarBotaoAnalise(scope.row.statusAnalise)',
                                v-if='interfaceUsuario === "revenda"'
                            )
                                | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.visualizarResposta') }}
            template(slot='empty')
                el-empty(:description='$t("mensagens.comuns.semDados")')

    .tabela-gestao-contrato-originacao__paginacao
        div
            span.pagina {{ this.paginacao.total }} {{ this.paginacao.total > 1 ? $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.territorios') : $t('mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.tabela.territorio') }}

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina + 1',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )
    .modal-responder-analise
        ModalResponderAnalise(
            :show='mostrarModalResponderAnalise',
            :layout='interfaceUsuario',
            :solicitacao='territorioSelecionado',
            @handleCloseModalResponderAnalise='handleCloseModalResponderAnalise',
            :visualizarResposta='visualizarResposta'
        )
</template>

<script>
import ModalResponderAnalise from '@/components/contratosOriginacao/ModalResponderAnalise.vue';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';

export default {
    name: 'TabelaSolicitacaoAnaliseCAR',
    components: {
        ModalResponderAnalise
    },
    props: {
        carregando: {
            type: Boolean,
            required: false
        },
        totalizador: {
            type: String,
            required: false
        },
        removendo: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            notificacaoExportarRelatorio: null,
            codigosRemover: {
                NAO_VISUALIZADO: 'NAO_VISUALIZADO',
                CONCLUIDO: 'CONCLUIDO'
            },
            contratosSelecionados: [],
            mostrarModalResponderAnalise: false,
            territorioSelecionado: {
                nomeTerritorio: null,
                analiseDataSolicitacao: null,
                analiseDataResposta: null,
                statusAnalise: null
            },
            interfaceUsuario: 'empresa',
            visualizarResposta: false,
            tabelaData: [],
            paginacao: [],
            carregandoTabela: false,
            carregandoBaixarLaudo: false,
            params: {
                page: 0,
                size: 10,
                sort: 'analiseDataSolicitacao',
                por: 'desc'
            }
        };
    },
    mounted() {
        this.buscarDados();
    },

    computed: {},
    methods: {
        async buscarDados() {
            this.carregandoTabela = true;
            await ContratoOriginacaoServiceEmpresa.buscarTerritoriosAnalise(
                this.$route.params.id,
                this.params
            )
                .then(({ data }) => {
                    this.tabelaData = data.itens;
                    this.paginacao = data.paginacao;
                })
                .catch(error => {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                    this.$router.push({
                        path:
                            '/rastreabilidade/empresa/contratos-originacao/' +
                            this.$route.params.id
                    });
                });
            this.carregandoTabela = false;
        },
        analisarSolicitacao(solicitacao) {
            if (
                this.interfaceUsuario === 'empresa' &&
                solicitacao.statusAnalise
            ) {
                this.visualizarResposta = true;
            }
            this.mostrarModalResponderAnalise = true;
            this.territorioSelecionado = solicitacao;
        },
        handleCloseModalResponderAnalise() {
            this.mostrarModalResponderAnalise = false;
            this.buscarDados();
        },
        habilitarBotaoAnalise(statusAnalise) {
            if (this.interfaceUsuario === 'empresa' && !statusAnalise) {
                return false;
            } else if (this.interfaceUsuario === 'revenda' && statusAnalise) {
                return false;
            } else {
                return true;
            }
        },
        getTotal() {
            if (this.paginacao.total) {
                return this.paginacao.total;
            } else {
                return 10000;
            }
        },
        mudarPagina(novaPagina) {
            this.paginacao.pagina = novaPagina - 1;
            this.params.page = novaPagina - 1;
            this.buscarContratosEmpresa();
        },
        async buscarContratosEmpresa() {
            this.carregandoTabela = true;
            try {
                const { data } =
                    await ContratoOriginacaoServiceEmpresa.buscarTerritoriosAnalise(
                        this.$route.params.id,
                        this.params
                    );
                this.tabelaData = data.itens;
                this.paginacao = data.paginacao;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosContrato'
                    )
                );
            }
            this.carregandoTabela = false;
        },
        baixarLaudo(idLaudo) {
            this.carregandoBaixarLaudo = true;
            try {
                ContratoOriginacaoServiceEmpresa.baixarLaudo(idLaudo)
                    .then(() => {
                        this.$notify.success(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.downloadRealizadoComSucesso'
                            )
                        );
                    })
                    .catch(() => {
                        this.$notify.error(
                            this.$t(
                                'mensagens.rastreabilidadeEmpresa.contratos.editarVisualizarContratoEmpresa.erroRealizarDownload'
                            )
                        );
                    });
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.erroBuscarDadosContrato'
                    )
                );
            }
            this.carregandoBaixarLaudo = false;
        }
    }
};
</script>
<style lang="scss">
#tabela-gestao-contrato-originacao-empresa {
    .tabela-gestao-contrato-originacao__tabela {
        width: 100%;
    }

    box-shadow: 0 0 10px rgb(0 0 0 / 10%);

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;
        thead.has-gutter {
            height: 67px;
            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }
    }
    .el-table__cell {
        font-size: 12px;
    }
    .is-leaf {
        font-size: 13px;
    }
    .status-processamento {
        max-width: 148px;
        word-break: break-word;
        font-size: 13px;
        line-height: 17px;
    }
    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina {
            color: var(--primary);
            font-weight: 600;
        }
    }
    .tabela-gestao-icone {
        i {
            font-size: 23px;
            cursor: pointer;
        }
    }
    .status-processamento__dias {
        font-size: 12px;
        font-style: italic;
        i {
            margin-right: 2px;
        }
        .texto-alert {
            columns: #f88342;
        }
    }

    .espacamento-totalizador {
        margin-left: 20px;
    }

    .el-icon {
        margin: 0 3px 0 0;
    }
}
.el-message-box__btns {
    display: flex;
    justify-content: space-between;
}
</style>
